export const cartTotal = (cartArr) => {
  let total = 0
  if (!cartArr) return total
  if (cartArr.length > 0) {
    for (let item of cartArr) {
      total += parseInt(item.product.price) * item.quantity
    }
  }
  // to convert to USD
  const formattedTotal = total.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  })

  return formattedTotal
}

export const cartQuantity = (cartArr) => {
  let quantity = 0
  if (!cartArr) return quantity
  if (cartArr.length > 0) {
    for (let item of cartArr) {
      quantity += item.quantity
    }
  }
  return quantity
}

export const getAverageRating = (reviews) => {
  if (!reviews || reviews.length === 0) return 0
  const sum = reviews.reduce((acc, review) => {
    return acc + review.rating
  }, 0)
  return Math.floor(sum / reviews.length)
}

export const emailValidator = (email) => {
  if (email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
    return true
  }
  return false
}

export const passwordValidator = (password) => {
  if (password.match(/^[A-Za-z]\w{7,14}$/)) {
    return true
  }
  return false
}

export const usernameValidator = (username) => {
  if (username.match(/^[A-Za-z][A-Za-z0-9_]{7,29}$/)) {
    return true
  }
  return false
}

export const formatCurrency = (amount) => {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  })
}

export function formatPhoneNumber(phoneNumber) {
  const cleaned = ("" + phoneNumber).replace(/\D/g, "")
  const match = cleaned.match(/^(\d{1})?(\d{3})(\d{3})(\d{4})(\d*)$/)
  if (match) {
    const intlCode = match[1] ? "1 " : ""
    const extension = match[5] ? ` ext ${match[5]}` : ""
    return [
      intlCode,
      "(",
      match[2],
      ") ",
      match[3],
      "-",
      match[4],
      extension,
    ].join("")
  }
  return phoneNumber
}

export const convertToCSV = (data, options = {}) => {
  const defaults = {
    delimiter: ",",
    quoteChar: '"',
    escapeChar: '"',
    header: true,
    includeEmptyValues: true,
    nullValue: "",
  }
  const settings = Object.assign({}, defaults, options)

  const headers = Object.keys(data[0]).join(settings.delimiter)
  const rows = data
    .map((row) => {
      return Object.values(row)
        .map((field) => {
          // Escape quotes and handle special characters
          if (typeof field === "string") {
            field = field.replace(
              new RegExp(settings.quoteChar, "g"),
              `${settings.escapeChar}${settings.quoteChar}`
            )
          }
          // Convert null values
          if (field === null && !settings.includeEmptyValues) {
            field = settings.nullValue
          }
          // Quote all values
          return `${settings.quoteChar}${field}${settings.quoteChar}`
        })
        .join(settings.delimiter)
    })
    .join("\n")

  let output = ""
  if (settings.header) {
    output += headers
  }
  output += `\n${rows}`

  return output
}

export const capitalizeFirstLetter = (string) => {
  if (!string) return ""
  return string.charAt(0).toUpperCase() + string.slice(1)
}
